var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex flex-wrap", class: _vm.alignmentClass },
    [
      _vm.noContent
        ? _c("span", { class: _vm.noContentClasses }, [
            _vm._v(" " + _vm._s(_vm.noContentPlaceholder) + " "),
          ])
        : [
            _vm._t(
              "default",
              function () {
                return _vm._l(_vm.itemsToRender, function (item) {
                  return _c("ItemChip", {
                    key: item.id,
                    attrs: {
                      itemId: item.id,
                      itemName: item.name,
                      itemRole: item.role,
                      itemExtra: item.extra,
                      adjustPadding: _vm.adjustPadding,
                      avatar: item.avatar,
                      routeName: _vm.routeName,
                      single: _vm.getSingle,
                      isPerson: _vm.isPerson,
                      routeParams: item.routeParams,
                      maxChipWidth: _vm.maxChipWidth,
                      textClasses: _vm.textClasses,
                      management: _vm.management,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ itemName }) {
                            return [
                              _vm._t("item", null, {
                                highlighted: item.highlighted,
                                itemName: itemName,
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  })
                })
              },
              { itemsToRender: _vm.itemsToRender }
            ),
            _vm.itemsMoreThanLimit && _vm.limit > 0
              ? _c(
                  "div",
                  {
                    staticClass:
                      "inline-block pb-0.5 plainBorder -mt-0.5 w-10 text-center hover:text-primary-500 hover:border-primary-500",
                  },
                  [
                    _c("button", { on: { click: _vm.moreResources } }, [
                      _c(
                        "span",
                        {
                          staticClass:
                            "text-label text-primary-500 underline focus:outline-none hover:no-underline",
                          class: _vm.textClasses,
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "text-xs font-semibold inline-block customPad rounded-full last:mr-0 mr-1",
                              class: _vm.allClasses,
                            },
                            [_vm._v(" + " + _vm._s(_vm.moreLinkNumber) + " ")]
                          ),
                        ]
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm.itemsMoreThanLimit && _vm.limit === 0
              ? _c(
                  "div",
                  {
                    staticClass:
                      "inline-block pb-0.5 contents -mt-0.5 w-10 text-center hover:text-primary-500 hover:border-primary-500",
                  },
                  [
                    _vm.limit === 0
                      ? _c("button", { on: { click: _vm.moreResources } }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-sm font-400 text-notification-blue focus:outline-none leading-normal",
                            },
                            [
                              _vm._v("View suggested resources"),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "ml-1 text-storm-gray text-sm font-400 leading-5",
                                },
                                [_vm._v("(" + _vm._s(_vm.moreLinkNumber) + ")")]
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }